import { PhaseTypeEnum } from '@vatos-pas/common';
import { getPhaseDisplayName, isAffectedPhase } from './phaseRelationships';

export interface RequestResourceLabelsInput {
  phaseType: PhaseTypeEnum;
  /** The modal logs a completed phase rather than requesting a resource. */
  isLogModal: boolean;
  /**
   * A bump logged on a Bumpout Timesheet subdivision is a request for a
   * Bumper, not a log entry, so it reads like a request.
   */
  isBumpoutTimesheetRequest: boolean;
}

export interface RequestResourceLabels {
  title: string;
  submitLabel: string;
}

const SUBMIT_REQUEST = 'Submit request';

export const getRequestResourceLabels = ({
  phaseType,
  isLogModal,
  isBumpoutTimesheetRequest,
}: RequestResourceLabelsInput): RequestResourceLabels => {
  const phaseDisplayName = getPhaseDisplayName(phaseType);

  if (!isLogModal) {
    return {
      title: isAffectedPhase(phaseType)
        ? `Assign Resource to ${phaseDisplayName}`
        : `Request Resource for ${phaseDisplayName}`,
      submitLabel: SUBMIT_REQUEST,
    };
  }

  if (isBumpoutTimesheetRequest) {
    return {
      title: `Request ${phaseDisplayName}`,
      submitLabel: SUBMIT_REQUEST,
    };
  }

  return { title: `Log - ${phaseDisplayName}`, submitLabel: 'Log' };
};
